import React, { Suspense, useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';

import Clients from './clients/Clients';
import StaffForAssignment from './assignStaff/StaffForAssignment';

import { userRoles, clientAssignmentType } from '../../constants';
import ProgramStaffAssignmentTab from './assignProgram/ProgramStaffAssignmentTab';
import Loading from '../shared/Loading';

function BottomTabs({ staff }) {
  const [currentTab, setCurrentTab] = useState("clients");

  const handleTabSwitch = (tab) => {
    setCurrentTab(tab);
  }

  return (
    <React.Fragment>

      <Tab.Container id="staff-tabs" activeKey={currentTab} onSelect={(tab) => handleTabSwitch(tab)}>
        <Nav variant="tabs" className="mt-5">

          <Nav.Item className="w-25 text-center">
            <Nav.Link eventKey="clients">Clients</Nav.Link>
          </Nav.Item>

          {staff.userRoleName === userRoles.MANAGER &&
            <Nav.Item className="w-25 text-center">
              <Nav.Link eventKey="staff">Staff</Nav.Link>
            </Nav.Item>
          }

          {staff.clientAssignmentType === clientAssignmentType.ClientsInAssignedPrograms && 
            <Nav.Item className="w-25 text-center">
              <Nav.Link eventKey="programs">Programs</Nav.Link>
            </Nav.Item>
          }
        </Nav>

        <Tab.Content className="basic-card">
          <Suspense fallback={<Loading />}>
            <Tab.Pane eventKey="clients" mountOnEnter unmountOnExit>
              <Clients staffId={staff.id} clientAssignmentType={staff.clientAssignmentType} />
            </Tab.Pane>

            {staff.userRoleName === userRoles.MANAGER &&
              <Tab.Pane eventKey="staff" mountOnEnter unmountOnExit>
                <StaffForAssignment managerId={staff.id} />
              </Tab.Pane>
            }

            {
              staff.clientAssignmentType === clientAssignmentType.ClientsInAssignedPrograms &&
              <Tab.Pane eventKey="programs" mountOnEnter unmountOnExit>
                <ProgramStaffAssignmentTab userId={staff.id} clientAssignmentType={staff.clientAssignmentType} />
              </Tab.Pane>
            }
          </Suspense>
        </Tab.Content>
      </Tab.Container>

    </React.Fragment>
  );
}

export default BottomTabs;
